<template>
  <div style="width: 100%">
    <div v-for="(item, index) in rowItem" :key="index" class="app-matrix-score">
      <div class="matrix-score-title">{{ item.rowItem }}</div>
      <div class="matrix-score-column" v-for="(i, idx) in item.column" :key="idx">
        <div class="column-title">
          {{ i.columnItem }}
        </div>
        <Rate
          v-model="i.score"
          void-icon="star"
          void-color="rgb(231, 231, 231)"
          color="rgb(255, 166, 0)"
          :size="28"
          :gutter="0"
          :disabled="disabled"
          :allow-half="allowHalf"
          @change="updataMatrixScore"
        />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { Rate, Field } from 'vant'
import cloneDeep from 'lodash/cloneDeep'

const props = defineProps({
  data: {
    required: true,
    type: Object,
    default: {}
  },
  disabled: {
    required: true,
    type: Boolean,
    default: false
  },
  allowHalf: {
    required: true,
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['updataMatrixScore'])

const rowItem = ref([])

const updataMatrixScore = () => {
  emit('updataMatrixScore', cloneDeep(rowItem.value))
}

const initData = () => {
  rowItem.value = cloneDeep(props.data.fieldContent)
}

onMounted(() => {
  if (props.data.fieldValue) {
    rowItem.value = props.data.fieldValue
  } else {
    initData()
  }
})
</script>

<style lang="less" scoped>
.app-matrix-score {
  width: 100%;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  overflow: hidden;
  &:not(:last-child) {
    margin-bottom: 8px;
  }
  .matrix-score-title {
    display: flex;
    align-items: center;
    min-height: 36px;
    background-color: rgb(245, 245, 245);
    padding: 0 16px;
    color: rgba(0, 0, 0, 0.5);
  }
  .matrix-score-column {
    padding: 0 16px;
    margin-bottom: 8px;
  }
  .column-title {
    color: rgba(0, 0, 0, 0.7);
    font-size: 16px;
    margin: 8px 0;
    line-height: 24px;
  }
}
</style>
